/**
 * Keyboard focus, one look everywhere: a 2px accent outline standing 2px off
 * the control.
 *
 * Before this, only three controls styled their focus; the rest fell back to
 * the browser's own outline, which came out as a heavy black box in the editor
 * and a 1px grey line, next to invisible, on the homepage's primary button —
 * the same role drawn by accident of the colours around it (motion audit,
 * 2026-09-27). An OUTLINE, not a ring: it composes with any shadow a control
 * already paints (the slider thumb's halo is an inline box-shadow a ring would
 * replace), and the offset is a true gap, so it needs no colour matched to
 * whatever the control sits on. The accent is the keyboard's current
 * position, which is the accent's one job.
 *
 * `outline-solid` is spelled out because a control that also carries
 * `outline-none` has zeroed the outline style, and width alone would draw
 * nothing. The colour is set at REST, not on focus: `transition-colors`
 * carries `outline-color`, so a colour switched on with the focus faded in
 * from `currentColor` — a white ring flashing round a dark button first.
 */
export const FOCUS_RING =
  'outline-[color:var(--rt-accent)] focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-2';

/** The same ring on a Segmented option's painted thumb, lit by the focus of the
 *  (larger, touch-sized) button around it, so it hugs what the eye sees. */
export const FOCUS_RING_ON_SEGMENT_THUMB =
  'outline-[color:var(--rt-accent)] group-focus-visible/seg:outline-2 group-focus-visible/seg:outline-solid group-focus-visible/seg:outline-offset-2';
